import { PoolData } from "../../model/poolData";
import { asSelectOptions, SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = PoolData;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getPools(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(apiUrls.getPools);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = asSelectOptions({
        data: response.data,
      });
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error fetching Pools:", err);
    return { error: (err as Error).message };
  }
}
